define('lq/visibility/defaultVisibility',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var DefaultVisibility = function () {
        this.bindings = undefined;
    };

    DefaultVisibility.prototype.apply = function (drop) {
        if (drop.data.initialVisibility === false)
            drop.initialHide();

        if (this.fromQuery(drop)) {
            drop.visibilityRegistrationId = drop.piping.datasources.registerDatasourceListener(
                drop.data.dataSourceForVisibility,
                function (data) {
                    var isVisible = data.results.length && data.results[0][drop.data.dataSourceOutputForVisibility];
                    if (isVisible === true)
                        drop.show();
                    else
                        drop.hide();
                }
            );
        } else if (this.fromParameter(drop)) {
            this.updateVisibilityFromParameter(drop);

            if (drop.data.parameterForVisibilityIsBound) {
                var callback = drop.updateVisibilityFromParameter
                    ? drop.updateVisibilityFromParameter.bind(this, drop)
                    : this.updateVisibilityFromParameter.bind(this, drop);
                var binding = drop.piping.parameters.subscribeForUpdates(drop.data.parameterForVisibility, callback);
                if(!this.bindings)
                    this.bindings = [];
                this.bindings.push(binding);
            }
        } else if (this.fromCondition(drop)) {
            var evaluator = drop.piping.conditions.getConditionEvaluator(drop.data.conditionForVisibility);
            evaluator.evaluate(drop.piping, null, false, true)
                .then(function (executionData) {
                    if (executionData.conditionResult) {
                        drop.showWithoutAnimation();
                    } else {
                        drop.hideWithoutAnimation();
                    }
                });
        } else if (this.fromParentState(drop)) {
            drop.hideWithoutAnimation();

            if (!drop.data.parentWithState) {
                _.each(drop.data.visibleWhenParentHasStates, function (state) {
                    drop.getElementForVisibility().addClass("visible-when-" + state);
                });
            } else {
                if (!$('#visibilityFromParentRules').length) {
                    $('<style type="text/css" id="visibilityFromParentRules" />')
                        .appendTo('head');
                }

                var parentWithState = this.getDropById(drop, drop.data.parentWithState);
                parentWithState.$element.addClass(`state-for-${drop.data.id}`);
                
                var rules = []; 
                
                _.each(drop.data.visibleWhenParentHasStates, function (state) {
                    var parentRule = `.state-for-${drop.data.id}.has-states${state === 'hover' ? ":" : "."}${state}`;
                    var visibilityRule = `visible-when-${state}-${drop.data.id}`;
                    
                    drop.getElementForVisibility().addClass(visibilityRule);
                    
                    var rule = `${parentRule} .${visibilityRule}`;
                    
                    if (!rules.includes(rule)) {
                        rules.push(rule);
                    }
                });

                var cssProperties = "{ visibility: inherit !important; display: block !important; }";

                var $visibilityFromParentRules = $('#visibilityFromParentRules');

                rules.forEach(function (rule) {
                    if (!$visibilityFromParentRules.html().includes(rule)) {
                        $visibilityFromParentRules.html(`${$visibilityFromParentRules.html()} ${rule} ${cssProperties} `);
                    } 
                });
            }
        }
    };

    DefaultVisibility.prototype.updateVisibilityFromParameter = function (drop) {
        if (this.valueFromParameterIsTrue(drop))
            drop.showWithoutAnimation();
        else
            drop.hideWithoutAnimation();
    };

    // note that this is a very naive implementation. It can use parameters that are passed in from another page,
    // but it won't be able to pick up parameters that are set during the PageLoad event or any other event.
    // If we need to support that second use case, we need to be able to listen to changes to parameter values
    DefaultVisibility.prototype.valueFromParameterIsTrue = function (drop) {
        var value = drop.piping.parameters.getValue(drop.data.parameterForVisibility);

        if (value === undefined)
            return false;

        if ($.type(value) === 'boolean')
            return value === true;

        if ($.type(value) === 'string')
            return value.toLowerCase() === 'true';

        throw new Error('Cannot determine the visibility of the drop. The value of parameter ' + drop.data.parameterForVisibility + ' cannot be converted to a boolean.');
    };

    DefaultVisibility.prototype.fromQuery = function (drop) {
        return drop.data.initialVisibilityOption === 'From Query' && drop.data.dataSourceForVisibility;
    };

    DefaultVisibility.prototype.fromParameter = function (drop) {
        return drop.data.initialVisibilityOption === 'From Parameter' && drop.data.parameterForVisibility;
    };

    DefaultVisibility.prototype.fromCondition = function (drop) {
        return drop.data.initialVisibilityOption === 'From Condition' && drop.data.conditionForVisibility;
    };

    DefaultVisibility.prototype.fromParentState = function (drop) {
        return drop.data.initialVisibilityOption === 'FromParentState' && drop.data.visibleWhenParentHasStates;
    };

    DefaultVisibility.prototype.cleanUp = function () {
        _.each(this.bindings, function (binding) {
            binding.dispose();
        });
        this.bindings = undefined;
    };

    DefaultVisibility.prototype.getDropById = function (drop, dropId) {
        while (drop.parent !== null) {
            if (drop.data.id === dropId) {
                return drop;
            }

            drop = drop.parent;
        }
    };

    return DefaultVisibility;
});
